import useFloating from 'hooks/layers/useFloating';
import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import { v4 as uuidv4 } from 'uuid';

const MESSAGEBOX_TYPE = 'MessageBox';
export default function useMessageBox(category) {
  const [id, _] = React.useState(() => uuidv4());
  const [list, setList] = Recoil.useRecoilState(AppStore.floatings.list(category));
  const [hash, setHash] = Recoil.useRecoilState(AppStore.floatings.hash(category));
  const {
    open,
    update,
    close,
  } = useFloating({
    options: {
      id,
      // reference, // no use
      placement: 'screen-center',
      connection: 'none',
      width: 'auto', // integer | 'auto'
      height: 'auto',
      veilable: true,
      stickable: false,
      movable: true,
      closable: true,
      modal: true,
      dim: 'transparent',
      tags: [], // optional
      type: MESSAGEBOX_TYPE,
      // title, // optional
      // description, // optional
      // contents, // required
      // buttons =[], // required
      // events = {}, // required
      // props, // no use
    },
    setList,
    setHash,
  });
  return {
    open,
    update,
    close,
  };
}
